import Input from "components/InvestorCommon/InputV2/Input";
import { ComponentProps, forwardRef } from "react";
import { IMAGES } from "utils/images";
import { SOURCE_OF_FUNDS_OTHERS_MAX_LENGTH } from "utils/individualInvestorClassification";

type Props = Omit<ComponentProps<typeof Input>, "title" | "titleClassName" | "maxLength"> & {
	value?: string;
	maxLength?: number;
};

const SourceOfFundsOthersInput = forwardRef<HTMLInputElement, Props>(
	function SourceOfFundsOthersInput(
		{
			disabled,
			errorMessage,
			value = "",
			style,
			maxLength = SOURCE_OF_FUNDS_OTHERS_MAX_LENGTH,
			...props
		},
		ref,
	) {
		const length = String(value ?? "").length;

		return (
			<div>
				<div
					className="mt-2 w-full"
					style={{
						backgroundColor: "#F7F8FE",
						padding: "12px",
						borderRadius: "5px",
					}}
				>
					<div
						className="mb-1 font-bold"
						style={{ color: "#2d3436", font: "normal normal bold 18px/22px Lato" }}
					>
						Other source of Fund <span className="text-red-500">*</span>
					</div>
					<div
						style={{
							color: "#999999",
							font: "normal normal normal 14px/18px Lato",
							marginBottom: "8px",
						}}
					>
						please specify your source of fund
					</div>
					<Input
						{...props}
						ref={ref}
						value={value}
						disabled={disabled}
						maxLength={maxLength}
						errorMessage={errorMessage}
						style={{
							backgroundColor: "#ffffff",
							fontSize: "18px",
							...(disabled ? { color: "#999999" } : {}),
							...style,
						}}
					/>
					<div
						style={{
							marginTop: "4px",
							textAlign: "right",
							color: "#999999",
							font: "normal normal normal 12px/16px Lato",
						}}
					>
						{length}/{maxLength}
					</div>
				</div>

				<div className="flex items-center gap-1 mt-1">
					<img src={IMAGES.icon.infoGray} alt="info" className="w-4 h-4" />
					<div className="text-sm font-normal pb-[2px]">
						Please provide details of the source of fund
					</div>
				</div>
			</div>
		);
	},
);

export default SourceOfFundsOthersInput;
